<script setup lang="ts">
import {useApiErrors} from "~/composables/useApiErrors"
import UpdateNotification from "~/components/UpdateNotification.vue"
import {useFirebaseApp} from "vuefire";
import {getMessaging} from "firebase/messaging";
import { useSnackbarStore } from '@/stores/SnackbarStore'

const {isAppLoaded} = useApp()
const snackbar = useSnackbarStore()
const {errorMessage, errorState} = useApiErrors()
const firebaseApp = useFirebaseApp()
const messaging = getMessaging(firebaseApp)

// Ознака про необхідність оновити сторінку
const updateAvailable = ref(false)

// Отримуємо сповіщення про успішний деплой нової версії застосунку
useRuntimeHook('app:manifest:update', () => {
  updateAvailable.value = true
})

messaging.onMessageHandler = (payload) => {
  if (Notification.permission === 'granted') {
    new Notification(payload.notification.title, {
      body: payload.notification.body,
      icon: payload.notification.icon,
    });
  }
}
</script>

<template>
  <NuxtLoadingIndicator color="rgb(var(--v-theme-app-loader))" />
  <AppLoader v-if="!isAppLoaded"/>
  <NuxtLayout v-else>
    <NuxtPage/>

    <SnackError
        v-model="errorState"
        :text="errorMessage"
        timeout="10000" />

    <GlobalSnackbar
        :error-msg="snackbar.message"
        :snackbar-actions="snackbar.customActions"
        :snackbar-show="snackbar.isOpen"
        :snackbar-status="snackbar.status"
    />
  </NuxtLayout>

  <UpdateNotification v-model="updateAvailable" />
</template>

<style>
ul, ol {
  padding-left: 30px;
}
</style>